// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3hMzE","container":"styles_container__IG7kC","title":"styles_title__33QoG","wrapper":"styles_wrapper__12L_1","answer":"styles_answer__1XFyl"};